export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              关于黑料
            </h2>
          </div>

          <div className="bg-background-100 rounded-xl p-6 md:p-10 border border-background-200/60">
            <p className="text-sm md:text-base leading-relaxed text-foreground-700">
              黑料吃瓜网成立于对真相与八卦的执着追求。我们相信，每一份<strong>黑料爆料</strong>背后都藏着值得被讲述的故事。平台汇聚全网最敏锐的吃瓜群众和最及时的<strong>黑料吃瓜在线</strong>资讯，从网红翻车到明星塌房，从选秀黑幕到资本大瓜，我们用最犀利的视角为你呈现<strong>吃瓜黑料合集</strong>的完整拼图。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              黑料吃瓜不打烊，是承诺更是态度。无论深夜还是清晨，总有新鲜<strong>黑料吃瓜视频</strong>等待你的检阅。我们不做谣言的搬运工，而是八卦真相的挖掘者——每一条<strong>黑料最新爆料</strong>都经过多方交叉验证，确保吃瓜吃得放心、吃得过瘾。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-xs text-primary-600 font-semibold bg-primary-50 px-4 py-2 rounded-full">
              <i className="ri-shield-check-line"></i>
              黑料吃瓜网 · 八卦有态度
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}